import { type UseMutationResult, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { WarrantParticipantService } from '../../services/wealthlane-captable-services';
import { useNavigate } from 'react-router-dom';
import ToastComponent from '../../components/toast';

const usePostWarrantExerciseSubmit = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<any | undefined, unknown, void, unknown> => {
  const navigate = useNavigate();

  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        WarrantParticipantService.postApiCapTableApiAppWarrantParticipantRequestExercise(payload)
      );
    },
    {
      onSuccess: (response: any) => {
        if (response?.isSuccess) {
          toast.success(<ToastComponent label='Success' message='Warrant exercise requested.' />);
          navigate('/holdings');
        } else {
          toast.error(<ToastComponent label='Error' message={response?.message || 'Exercise request failed.'} />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostWarrantExerciseSubmit;
